<app-magic-link *ngIf="!loggingIn" (loginSuccess)="login($event)"></app-magic-link>
<mat-progress-spinner mode="indeterminate" *ngIf="loggingIn"></mat-progress-spinner>
<p class="text-error" *ngIf="error">{{error}}</p>
